import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap items-center gap-x-4 gap-y-3 rounded-catering-md border border-catering-cream-500 bg-gradient-to-b from-catering-lemon-100 to-catering-cream-200 px-4 py-3.5 font-catering-body",
  role: "status"
}
const _hoisted_2 = { class: "ml-auto flex flex-wrap items-center gap-3.5" }

import { XMarkIcon } from '@heroicons/vue/24/outline'
import { computed, onMounted } from 'vue'
import { useStore } from 'vuex'

import { neueButtonClasses } from '@/components/neue/neueButtonClasses'
import { showsAiAgentsNav, useAgentSetupStatus } from '@/composables/useAgentSetupStatus'
import { WIZARD_PATH } from '@/config/agentWizardSteps'


export default {
  __name: 'AgentSetupBanner',
  setup(__props) {

const store = useStore()
const { status, load, dismiss } = useAgentSetupStatus()

const visible = computed(
  () => showsAiAgentsNav(store) && status.value?.agents_count === 0 && !status.value.dismissed_at
)

onMounted(() => {
  if (showsAiAgentsNav(store)) load().catch(() => {})
})

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (visible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "agent-setup-banner__dot bg-catering-lemon-600",
          "aria-hidden": "true"
        }, null, -1)),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "min-w-[14rem] flex-1" }, [
          _createElementVNode("p", { class: "text-[14.5px] font-bold leading-tight text-catering-ink-900" }, "Put your texting on autopilot"),
          _createElementVNode("p", { class: "mt-0.5 text-[12.5px] leading-snug text-catering-ink-600" }, " Four AI agents can win back lapsed customers, rescue abandoned carts, add to orders before cutoff and collect reviews. Set them up in about ten minutes. Nothing goes live until you say so. ")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: _unref(WIZARD_PATH),
            class: _normalizeClass(_unref(neueButtonClasses)({ type: 'accent', size: 'sm' }))
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" Set up AI agents → ", -1)
            ]))]),
            _: 1
          }, 8, ["to", "class"]),
          _createElementVNode("button", {
            type: "button",
            "aria-label": "Dismiss",
            class: "rounded-full p-1 text-catering-ink-500 hover:bg-catering-cream-300",
            onClick: _cache[0] || (_cache[0] = (...args) => (_unref(dismiss) && _unref(dismiss)(...args)))
          }, [
            _createVNode(_unref(XMarkIcon), { class: "h-4 w-4" })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}